// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import { HSStaticMethods } from "preline/preline"

// Initialize Preline components
document.addEventListener("DOMContentLoaded", function() {
  HSStaticMethods.autoInit();
});

// Re-initialize Preline on Turbo navigation
document.addEventListener("turbo:load", function() {
  HSStaticMethods.autoInit();
});
